module.exports = __webpack_public_path__ + "img/5.c344c331.png";